export default __webpack_public_path__ + "static/jared_bw_web-250652313aa31451b7fe57a3c77a95aa.jpg";